import styled from 'styled-components';

export default styled.div`
  display: flex;
  height: 100%;

  .opener {
    background-color: transparent;
    border: 0;
    cursor: pointer;
    outline: none;
    width: 32px;
    height: 32px;

    &:hover,
    &--active {
      background-color: var(--primary300);

      svg {
        fill: var(--white);
      }
    }
  }

  .tooltip {
    background-color: var(--white);
    border-radius: 8px;
    box-shadow: 0 4px 14px 0 rgba(0, 0, 0, 0.2);
    opacity: 1;
    padding: ${({ theme }) => theme.base.gridSizes.XS} ${({ theme }) => theme.base.gridSizes.S};
  }

  .menu {
    display: flex;
    flex-direction: column;
    margin: 0;
    padding: 0;

    &-item {
      list-style: none;
      margin: 0.5rem 0;
    }

    &-button {
      background-color: var(--white);
      border: 0;
      color: var(--grey800);
      cursor: pointer;
      font-weight: normal;
      outline: none;
      margin: 0;
      padding: 0;
      &:hover {
        color: var(--grey900);
      }
    }
  }

  svg {
    height: 16px;
    width: 16px;
  }

  .radio-question {
    display: flex;

    label {
      margin-bottom: 1rem;
      margin-right: 0;
    }
  }
`;
